
<div class="mainContent" *ngIf="!showerror">
  <div class="background">
    <div class="imgBackground">
      <img alt="img" class="main-image" src="./assets/Temp_Background.png" />
    </div>
  </div>
  <div class="heading" style="color: black;">Config Execution Agent</div>
  <div class="subHeading" style="color: black;">The Configuration Hub enables automated instance creation thus bringing
    efficiencies and
    shrinking release timeline</div>

  <div class="project-container">
    <div class="project" style="color: black;">
      Select the category to Generate the output <span style="font-size: 14px; color: #ff1f1f"></span>
      <br><br>
      <p class="action-instruction" style="color: black;">Select one of the actions to perform</p>
    </div>



    <!-- <select class="select-css" [(ngModel)]="projid" (change)="selectProject(projid)" [disabled]="dropdownDisabled">
      <option class="option" value="null">Select</option>
      <option class="option" style="font-weight: 600" *ngFor="let project of fetchProject" [ngValue]="project">
        {{ project.projectname }}
      </option>
    </select> -->

    <div class="custom-dropdown" [ngClass]="{'disabled': dropdownDisabled}" aria-disabled="dropdownDisabled">
      <div class="custom-dropdown-display" [ngClass]="{'disabled': dropdownDisabled}">
        <span class="custom-dropdown-projectname">{{ projid?.projectname || 'Select' }}</span>
        <svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.61061 3.56998C2.81675 3.79764 3.18325 3.79764 3.38939 3.56997L5.87098 0.82927C6.1637 0.505978 5.92612 1.85966e-05 5.48159 1.85966e-05H0.518411C0.0738785 1.85966e-05 -0.163702 0.505979 0.129025 0.829271L2.61061 3.56998Z"
            fill="#8C95A1" />
        </svg>

      </div>

      <div class="custom-dropdown-panel" *ngIf="!dropdownDisabled">
        <div (click)="selectProject('null')">
          Select
        </div>
        <div *ngFor="let project of fetchProject" (click)="selectProject(project)">
          {{ project.projectname }}
        </div>
      </div>
    </div>
  </div>
  <mat-grid-list cols="5" class="gridSpace">
    <mat-grid-tile>
      <button mat-flat-button class="btnLikeCard" [ngStyle]="{ 'background-color': backcolor }" [disabled]="btnDisabled"
        [routerLink]="['/cloud-extract']" (click)="maskPage()">
        <div class="icon icon2" [ngStyle]="{ 'background-color': iconbackcolor }">
          <img alt="img" class="imgAlign" src="./assets/Cloud_Extract_Icon.svg" />
        </div>
        <div class="cardHeading ">
          <p class="cText2" [ngStyle]="{ color: headingColor }">
            Cloud Extract

          </p><br><br>

          <!-- Line below the Cloud Extract tile -->
          <div class="custom-line custom-line1"></div>
        </div>
        <div class="lineHeight">
          <p class="letSpace" [ngStyle]="{ color: textColor }">Extract configurations</p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">from Oracle Cloud</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-flat-button [routerLink]="['/config-workbook']" [disabled]="btnDisabled" class="btnLikeCard"
        [ngStyle]="{ 'background-color': backcolor }">
        <div class="icon icon4" [ngStyle]="{ 'background-color': iconbackcolor }">
          <img alt="img" class="imgAlign" src="./assets/config-icon2.svg" />
        </div>
        <div class="cardHeading ">
          <p class="cText4" [ngStyle]="{ color: headingColor }">
            Config Workbook
          </p><br><br>

          <!-- Line below the Cloud Extract tile -->
          <div class="custom-line custom-line2"></div>
          <p class="cText4" [ngStyle]="{ color: headingColor }"></p>
        </div>
        <div class="lineHeight">
          <p class="letSpace" [ngStyle]="{ color: textColor }">
            Generate config workbook
          </p>

          <p class="letSpace" [ngStyle]="{ color: textColor }">Compare configurations</p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">for two cloud instances</p>
        </div>
      </button>

    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-flat-button class="btnLikeCard" [ngStyle]="{ 'background-color': backcolor }" [disabled]="btnDisabled"
        [routerLink]="['/cloud-load']" (click)="maskPage()">
        <div class="icon icon3" [ngStyle]="{ 'background-color': iconbackcolor }">
          <img alt="img" class="imgAlign" src="./assets/Cloud_Load_Icon.svg" />
        </div>
        <div class="cardHeading ">
          <p class="cText3" [ngStyle]="{ color: headingColor }">Cloud Load</p>
          <br><br>

          <!-- Line below the Cloud Extract tile -->
          <div class="custom-line custom-line3"></div>
        </div>
        <div class="lineHeight">
          <p class="letSpace" [ngStyle]="{ color: textColor }">Load configurations</p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">to Oracle Cloud</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-flat-button [routerLink]="['/config-compare']" [disabled]="btnDisabled" class="btnLikeCard"
        [ngStyle]="{ 'background-color': backcolor }">
        <div class="icon icon6" [ngStyle]="{ 'background-color': iconbackcolor }">
          <img alt="img" class="imgAlign" src="./assets/compare-icon2.svg" />
        </div>
        <div class="cardHeading">
          <p class="cText6" [ngStyle]="{ color: headingColor }">
            Config Compare

          </p><br><br>

          <!-- Line below the Cloud Extract tile -->
          <div class="custom-line custom-line4"></div>

        </div>
        <div class="lineHeight">
          <p class="letSpace" class="letSpace" [ngStyle]="{ color: textColor }">
            Generate config compare
          </p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">configurations for</p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">two cloud instances</p>
        </div>
      </button>
    </mat-grid-tile>

    <mat-grid-tile *ngIf="showConfigBuild">
      <button mat-flat-button [routerLink]="['/config-build']" [disabled]="btnDisabled" class="btnLikeCard"
        [ngStyle]="{ 'background-color': backcolor }">
        <div class="icon icon7" [ngStyle]="{ 'background-color': iconbackcolor }">
          <img alt="img" class="imgAlign" src="./assets/compare-icon2.svg" />
        </div>

        <div class="cardHeading ">
          <p class="cText7" [ngStyle]="{ color: headingColor }">
            Predicted Configurations

          </p><br><br>

          <!-- Line below the Cloud Extract tile -->
          <div class="custom-line custom-line5"></div>
        </div>
        <div class="lineHeight">
          <p class="letSpace" [ngStyle]="{ color: textColor }">Repository of Gen AI predicted
          </p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">configurations for the project
          </p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">through Auto-Config tool,
          </p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">Validate and Mark
          </p>
          <p class="letSpace" [ngStyle]="{ color: textColor }">completed tasks.
          </p>

        </div>

      </button>
    </mat-grid-tile>
  </mat-grid-list>

  <dcon-auth></dcon-auth>

  <div class="mainContent" *ngIf="showerror">
    <h2 style="margin-top: 40px; text-align: center">
      <b>
        <i class="fa fa-lock"></i> Looks like you do not have access to this
        page
      </b>
    </h2>
  </div>
</div>
